import {ChatNotesError} from './errors';

const DEFAULT_TIMEOUT_MS = 5000;

interface ChatNotesEnvironment {
  VITE_CHAT_NOTES_CORE_URL?: string;
  VITE_CHAT_NOTES_REQUEST_TIMEOUT_MS?: string;
  VITE_CHAT_NOTES_WEBK_BRIDGE?: string;
}

export type ChatNotesIntegrationConfig =
  {enabled: false} |
  {enabled: true; baseUrl: string; timeoutMs: number; webkBridgeEnabled: boolean};

export function readChatNotesIntegrationConfig(
  environment: ChatNotesEnvironment
): ChatNotesIntegrationConfig {
  const baseUrl = environment.VITE_CHAT_NOTES_CORE_URL?.trim();
  if(!baseUrl) return {enabled: false};

  const timeoutValue = environment.VITE_CHAT_NOTES_REQUEST_TIMEOUT_MS?.trim();
  const timeoutMs = timeoutValue ? Number(timeoutValue) : DEFAULT_TIMEOUT_MS;

  if(!Number.isFinite(timeoutMs) || timeoutMs <= 0) {
    throw new ChatNotesError(
      'INVALID_CONFIGURATION',
      'VITE_CHAT_NOTES_REQUEST_TIMEOUT_MS must be a positive number.'
    );
  }

  const bridgeValue = environment.VITE_CHAT_NOTES_WEBK_BRIDGE?.trim();
  if(bridgeValue && bridgeValue !== 'true' && bridgeValue !== 'false') {
    throw new ChatNotesError(
      'INVALID_CONFIGURATION',
      'VITE_CHAT_NOTES_WEBK_BRIDGE must be true or false.'
    );
  }

  return {enabled: true, baseUrl, timeoutMs, webkBridgeEnabled: bridgeValue === 'true'};
}
